import { useState } from 'react'
import ReactGA from 'react-ga4'
import { NavLink } from 'react-router-dom'
import '../styles/footer.scss'

export const Footer = ({ language }) => {
    const [email, setEmail] = useState('')

    // Footer content based on language
    const footerContent = {
        ENG: {
            newsletterLabel: 'Subscribe to our mailing list to receive the latest information!',
            emailPlaceholder: 'Your Email',
            subscribeButton: 'Subscribe',
            devImages: 'Images taken from a version in development.',
            nintendoCR:'Nintendo Switch is a trademark of Nintendo.',
            ratingPath: 'rating.png',
        },
    }

    const content = footerContent['ENG']    

    return (
        <>
            <footer>
                <div className='socials-wrapper'>
                    <div className='footer-nav-social'>
                        <div className='socials-list'>
                            <a
                                className='social-x'
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Socials',
                                        label: `NIS Twitter`,
                                    })
                                }}
                                aria-label='Twitter'
                                href='https://twitter.com/nisamerica'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Twitter'
                            >
                                <img
                                    alt='X logo'
                                    src={`${process.env.PUBLIC_URL}/img/footer/x.png`}
                                    style={{ width: '50px', height: 'auto' }}
                                />
                            </a>
                            <a
                                className='social-fb'
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Socials',
                                        label: `NIS Facebook`,
                                    })
                                }}
                                aria-label='Facebook'
                                href='https://www.facebook.com/NISAmericaInc/'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Facebook'
                            >
                                <i className='fab fa-facebook-f fa-2x'>
                                    <img
                                        style={{
                                            width: '50px',
                                            height: '50px',
                                        }}
                                        src={`${process.env.PUBLIC_URL}/img/footer/facebook.svg`}
                                        alt='facebook icon'
                                    />
                                </i>
                            </a>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Socials',
                                        label: `NIS Instagram`,
                                    })
                                }}
                                aria-label='Instagram'
                                href='https://www.instagram.com/nisamerica/'
                                target='_blank'
                                rel='noreferrer'
                                className='social-ig'
                                data-label='Instagram'
                            >
                                <i className='fab fa-instagram fa-2x'>
                                    <img
                                        style={{
                                            width: '60px',
                                            height: '60px'
                                        }}
                                        src={`${process.env.PUBLIC_URL}/img/footer/instagram.svg`}
                                        alt='ig icon'
                                    />
                                </i>
                            </a>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Socials',
                                        label: `NIS YouTube`,
                                    })
                                }}
                                aria-label='YouTube'
                                href='https://www.youtube.com/user/NISAmerica'
                                target='_blank'
                                rel='noreferrer'
                                className='social-yt'
                                data-label='YouTube'
                            >
                                <i className='fab fa-youtube fa-2x'>
                                    <img
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                        }}
                                        src={`${process.env.PUBLIC_URL}/img/footer/youtube.svg`}
                                        alt='youtube icon'
                                    />
                                </i>
                            </a>
                        </div>
                    </div>{' '}
                </div>
                <div className='mailchimp-wrapper'>
                    <form
                        action='https://nisamerica.us11.list-manage.com/subscribe/post?u=e8fc423eff95099d1ffcc6009&amp;id=349f7d20f9'
                        method='post'
                        id='mc-embedded-subscribe-form'
                        name='mc-embedded-subscribe-form'
                        className='validate'
                        target='_blank'
                        noValidate=''
                    >
                        <div id='mc_embed_signup_scroll' className='mailchimp text-center'>
                            <div>
                                <label htmlFor='mce-EMAIL' className='subscribe text-base'>
                                    {content.newsletterLabel}
                                </label>
                            </div>
                            <div className=''>
                                <div className='subscribe-wrapper'>
                                    <input
                                        className=''
                                        type='email'
                                        placeholder={content.emailPlaceholder}
                                        value={email}
                                        name='b_e8fc423eff95099d1ffcc6009_349f7d20f9'
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <button
                                        onClick={() => {
                                            ReactGA.event({
                                                action: 'click',
                                                event: 'link',
                                                category: 'Socials',
                                                label: `NIS Subscribe Newsletter`,
                                            })
                                        }}
                                    >
                                        {content.subscribeButton}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className='platforms'>
                    <div className='esrb'>
                        <img src={`${process.env.PUBLIC_URL}/img/footer/rp.svg`} alt='esrb rating' />
                    </div>
                
                    <img
                        style={{
                            width: '300px',
                            height: 'auto',
                            margin: '0px 20px',
                            borderRadius: '10px',
                        }}
                        alt={'steam logo'}
                        src={`https://nisamerica.com/public/assets/logo/steam-white.svg`}
                    />
                    <img alt='Nintendo Switch' src={`https://nisamerica.com/public/assets/logo/nsw.svg`} style={{width: '250px'}}/>
                </div>
                <div className='developer pt-4'>
                    <div>
                        <img
                            style={{
                                width: '200px',
                                height: 'auto',
                                padding: '10px'
                            }}
                            alt={'Nipponichi software'}
                            src={`${process.env.PUBLIC_URL}/img/footer/broc.png`}
                        />
                    </div>
                    <div>
                        <img
                            style={{
                                width: '200px',
                                height: 'auto',
                                padding: '10px'
                            }}
                            alt={'Nipponichi software'}
                            src={`${process.env.PUBLIC_URL}/img/footer/super.png`}
                        />
                    </div>
                    <div>
                        <img
                            style={{
                                width: '200px',
                                height: 'auto',
                                padding: '10px'
                            }}
                            alt={'Nipponichi software'}
                            src={`${process.env.PUBLIC_URL}/img/footer/gem.png`}
                        />
                    </div>
                    <div>
                        <img
                            style={{
                                width: '150px',
                                height: 'auto',
                            }}
                            alt='NIS logo'
                            src={`https://nisamerica.com/public/assets/logo/nisa.webp`}
                        />
                    </div>{' '}
                </div>
                <div className='copyrights'>
                    <div className=''>
                        <p className=''>
                            ©SuperNiche LLC / BROCCOLI Co., Ltd, Published by NIS America, Inc.<br/>
                            Developed by Gemdrops, Inc.
                        </p>
                        <p style={{ marginTop: '10px' }}> {content.nintendoCR}</p>
                        <p style={{ marginTop: '10px' }}>
                            ©2025 Sony Interactive Entertainment LLC. "<span className='font-sie'>1</span>",
                            "PlayStation", "<span className='font-sie'>5</span>", "PS5",{' '}
                            <span className='font-sie'>4</span>, "PS4", "<span className='font-sie'>0</span>" and "Play
                            Has No Limits" are registered trademarks or trademarks of Sony Interactive Entertainment
                            Inc.
                        </p>
                        <p style={{ marginTop: '10px' }}>
                            ©2025 Valve Corporation. Steam and the Steam logo are trademarks and/or registered
                            trademarks of Valve Corporation in the U.S. and/or other countries. All rights reserved.
                        </p>
                        <p style={{ marginTop: '10px' }}>
                            The rating icon is a trademark of the Entertainment Software Association. All other
                            trademarks are properties of their respective owners.
                        </p>
                        <p className='mt-4' style={{ marginTop: '25px' }}>
                            Screenshots are captured from a development build of the game.
                        </p>
                    </div>{' '}
                </div>
            </footer>{' '}
        </>
    )
}
